import React, {useState} from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from '@headlessui/react';
import {platforms} from './helper';
 import ProjectIntegrationForm from './forms/projectIntegrationForm';
import { H1Header } from '../../shared/components/others';
import { trackPlatformUsed } from '../../shared/utils/trackers';

const SelectPlatform = () => {
  const { t } = useTranslation();
  const [platform, setPlatform] = useState({});
  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = (platform) => {
    setPlatform(platform);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <div>
      <Helmet>
        <title>{t('select-platform', 'Sélectionner la plateforme')} | BotBlogR</title>
        <meta
          name="description"
          content="Vision générale de votre compte et de vos activités."
        />
      </Helmet>

      <div className="px-2 pl-6 pr-6">
        <div className="flex items-center justify-between py-3">
          <H1Header title={t('select-platform', 'Sélectionner la plateforme')} />
        </div>
      </div>

      <div className="p-4">
        <div className="flex flex-wrap justify-center mt-10 gap-6">
          {platforms.map((platform) => (
            <div
              key={platform.name}
              onClick={() => {
                trackPlatformUsed("project", `select_platform_${platform.name.toLowerCase()}`);
                handleOpenModal(platform)
              }}
              className="w-full sm:w-1/3 max-w-xs bg-white shadow-lg rounded-lg p-4 flex flex-col items-center cursor-pointer transform transition-transform hover:scale-105"
            >
              <div className="flex justify-center items-center h-32 w-full">
                <img
                  src={platform.logo}
                  alt={`${platform.name} logo`}
                  className="h-20 object-contain"
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        className='relative z-[999]'
      >
        <DialogBackdrop
          transition
          className='fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in'
        />

        <div className='fixed inset-0 z-[999] w-screen overflow-y-auto bg-black/50'>
          <div className='flex min-h-full justify-center p-4 text-center items-center sm:p-0'>
            <DialogPanel
              transition
              className='relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-4 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in max-sm:8/12 md:w-6/12 lg:w-4/12 sm:p-8 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95'
            >
              <button
                className='absolute top-2 right-3 text-gray-400 hover:text-gray-600 focus:outline-none text-2xl'
                onClick={handleCloseModal}
              >
                <span className='sr-only'>Close</span>
                &#10005;
              </button>

              <div className=''>

                <DialogTitle
                  as='h3'
                  className='text-xl font-semibold leading-6 text-gray-900'
                >
                  {platform?.title}
                </DialogTitle>
                
                <a
                    href={platform?.tuto?.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-500 text-sm hover:underline"
                >
                    {platform?.tuto?.text}
                </a>

                {platform &&
                  <div className="mt-6">
                    <ProjectIntegrationForm platform_name={platform?.name?.toLowerCase()} />
                  </div>
                }

              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default SelectPlatform;
